var consts = require('./constants');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');


function LeadFormField($field, enabledValidators) {
    this.enabledValidators = enabledValidators;
    this.$field = $field;
    this.$container = $field.parent('.form-group');
    this.$feedback = this.$container.find('.form-control-feedback');
    this.lastValidationPromise;

    this.attachEvents();
}

/**
 * Add field events listeners
 */
LeadFormField.prototype.attachEvents = function() {
    this.$field.on('change', this.validate.bind(this));
};

/**
 * Get the specified validator of the field
 * @param  {String} vaidatorName
 * @return {Function}
 */
LeadFormField.prototype.getValidator = function(vaidatorName) {
    var fieldName = this.$field.attr('name');
    var fieldValidators = consts.FIELDS_VALIDATORS[fieldName];

    if(fieldValidators && fieldValidators[vaidatorName]) {
        return fieldValidators[vaidatorName];
    }
};

/**
 * Check is the validator enabled for the field
 * @param  {String}  vaidatorName
 * @return {Boolean}
 */
LeadFormField.prototype.isValidatorEnabled = function(vaidatorName) {
    return this.enabledValidators.indexOf(vaidatorName) !== -1;
};

/**
 * Validate the field using the specified validator of supported validators
 * @param  {String} vaidatorName
 * @param  {String} value
 * @return {Promise}
 */
LeadFormField.prototype.validateBy = function(vaidatorName, value) {
    var validator = this.getValidator(vaidatorName);
    if(validator && this.isValidatorEnabled(vaidatorName)) {
        return validator(value);
    }

    return $.when(true);//Promise.resolve();
};

/**
 * Validate the field using enabled of supported validators
 * It goes through validators,
 * if a validator passes the next validator is called,
 * otherwise it returns rejected promise
 * @return {Promise}
 */
LeadFormField.prototype.validate = function() {
    var value = this.$field.val();
    var self = this;

    this.lastValidationPromise = self.validateBy(consts.BASIC_VALIDATOR, value).then(function(val) {
        return val && self.validateBy(consts.VERIFICATION_VALIDATOR, value);
    }).then(function(val) {
        var valid = val;
        if(typeof val === 'object'){
            valid = val.isValid;
        }
        return valid && self.validateBy(consts.BLACK_LIST, value);
    }).then(function(val) {
        self.setValid(val);
        eventToolbox.fireCustomEvent('validation', {
            'field':self.$field,
            'value': val
        });
        return val;
    }, function() {
        self.setValid(false);
        eventToolbox.fireCustomEvent('validation', {
            'field':self.$field,
            'value': false
        });
        return false;
    });


    return this.lastValidationPromise;
};

/**
 * Check if the field is valid
 * @return {Promise}
 */
LeadFormField.prototype.isValid = function() {
    if(!this.lastValidationPromise) {
        this.validate();
    }

    return this.lastValidationPromise;
};

/**
 * Mark the field as valid or invalid
 * @param {Boolean} isValid
 */
LeadFormField.prototype.setValid = function(isValid) {
    this.$field.toggleClass('form-control-danger', !isValid);
    this.$field.toggleClass('form-control-success', isValid);
    this.$container.toggleClass('has-danger', !isValid);
    this.$container.toggleClass('has-success', isValid);
};

module.exports = function($field, enabledValidators) {
    return new LeadFormField($field, enabledValidators);
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/lead/form-field.js
// module id = 138
// module chunks = 0 1 16 19 21